import { render, staticRenderFns } from "./ProdutoCreate.vue?vue&type=template&id=2756c058"
import script from "./ProdutoCreate.vue?vue&type=script&lang=js"
export * from "./ProdutoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports